import { RootState } from '@app/store';

export const selectSubmitPromoCodes = (state: RootState) =>
  state.submitPromoCodes;
